import { Observable } from "rxjs";
import { ValidatorFn } from "@angular/forms";

export interface UserData {
    admin_id: number,
    contact: string,
    customer: { customer_id: number, customer_name: string, compliance_level: ('high' | 'low' | 'medium')[] },
    email: string,
    first_name: string,
    is_active: boolean,
    last_name: string,
    temp_preference: string,
    timezone: string,
    userRoles: { role_id: number, role_name: string, privilege: number },
    user_id: number,
    notificationCount : number,
    application_id: Application[],
}
export interface Application {
    id: number,
    name: string,
    capabilities?: any[],
    allowedOrigin?: ('dev' | 'stage' | 'prod' | 'pre-prod')[],
    custom:boolean;
}

export interface capability {
    id: number;
    icon: string;
    name: string;
    unit: string;
    color: string;
}
export interface NzTreeNode {
    level: number;
    title: string;
    key: string;
    nestedGroupName?: string;
    children?: NzTreeNode[];
    isLeaf?: boolean;
    expanded?: boolean;
    locData?: any;
    type: 'location' | 'group';
    parent?: any;
    expandable: boolean;
    isNew?: boolean;
}

export interface SpocDetail {
    name: string;
    email: string;
    contact: string;
    designation: string;
}

export interface Location {
    location_id?: number;
    registered_name: string;
    ancestors: string[];
    spoc_detail: SpocDetail[];
    display_name: string;
    registered_address: string | null;
    customer_id: number;
    is_deleted: boolean;
}

export interface GenericConfirmationDialog {
    URL?: string | null,
    displayInput: string[]
}

export interface Settings {
    user_id?: number;
    temp_preference?: string;
    timeZone_preference?:string;
}

export enum ReportType {
    device = 'device_report',
    audit = 'audit_log_report',
    asset = 'asset_summary_report',
    incident = 'incident_summary_report',
    daily = 'daily_summary_report',
}

export interface MenuItem {
    icon?: string;
    type: 'link' | 'submenu';
    label: string;
    routerLink?: string;
    accessRight?: number[];
    children?: MenuItem[];
    queryParams?: any;
    permission?: AppRoutePermission;
}

export interface filterConfig {
    model: string;
    fields: filterField[];
}

export interface SelectOption {
    label: string;
    value: any;
    checked?: boolean;
}

export interface filterFieldBase {
    name: string;
    label: string;
    type: 'text' | 'select' | 'multiselect' | 'checkbox' | 'date' | 'radio' | 'textarea' | 'button' | 'divider' | 'p-select';
    validatorFn?: ValidatorFn[]
    validators?: string[];
    validationMessages?: { [errorKey: string]: string };
    multiple?: boolean;
    /**
     * The column width for the filter field. Must be a number less than or equal to 24.
     */
    columnWidth?: number;
    placeholder?: string;
    disabled?: boolean;
}

export interface filterFieldStatic extends filterFieldBase {
    optionsAsync?: false;
    options?: SelectOption[];
}

export interface filterFieldAsync extends filterFieldBase {
    optionsAsync: true;
    options: Observable<SelectOption[]>;
}

export interface filterFieldPSelect extends filterFieldBase {
    type: 'p-select';
    service: any;
    optionsAsync?: false;
    options?: SelectOption[];
    payload: any;
    listName: string;
    method: string;
    nzLabel: string[];
    nzValue: string;
    limitText: string;
}

export type filterField = filterFieldStatic | filterFieldAsync | filterFieldPSelect;

export interface ReportCard {
    name: string;
    description: string;
    accessRight: boolean;
    application: 'storage' | 'transport';
    disable?: boolean;
}

export interface ReportForm {
    deviceeui?: string[],
    reading_type?: string,
    start_date?: string,
    end_date?: string,
    start_month?: string,
    end_month?: string,
    user_id?: number | string,
    timezone: string,
    audit_category?: string,
    location?: number[],
    idt_asset?: number[],
    asset_ids?: number[],
    threshold_on?: string,
    incident_length?: string,
    incident_status?: string,
    users?: string[],
    customer_name: string,
    last_update_user: string,
    user_email: string,
    on_location?: number[],
    severity?: string,
    transporter_ids?: number[],
    sender_location_ids?: number[],
    destination_location_ids?: number[],
    delay_period?: string[],
    incident_duration?: string[],
}

export interface AppRoutePermission {
    allowedProducts?: string[];
    accessRight?: number[];
}

export interface TrIncidentFormConfig { form_name: string, form_type: string, fields: filterField[] }


export interface ViewOptions {
    view?: ('graph' | 'readings')[];
    radio?: { show: boolean; disable: boolean };
    dateRange?: { show: boolean; disable: boolean };
    allowZoom?: boolean;
    showTitle?: boolean;
    showDownloadButton?: boolean;
}
export interface TrMetaDataBase extends GraphMetaDataBase {
    id: number | string;
    page: 'trip' | 'tr-incident';
    date?: [string, string | null] | [];
    trip_start_date?: string;
    trip_status?: string;
}

export interface StorageMetaDataBase extends GraphMetaDataBase {
    id: number | string;
    page: 'asset' | 'storage-incident';
    date?: [string, string | null] | [];
}

export interface GraphMetaDataBase {
    id: number | string;
    page: 'trip' | 'tr-incident' | 'storage-incident' | 'asset';
    date?: [string, string | null] | [];
}

export interface StandardResponse<T> {
    status: number;
    data: T;
    message: string;
}

export type TicketStatusType = 'open' | 'in-progress' | 'resolved' | 'closed';
export interface SupportTicket {
  subject: string;
  ticket_id: number;
  user_subject: string;
  status: TicketStatusType;
  description: string;
  user_description: string;
  user_id?: number;
  customer_id?: number;
  email?: string;
  role_id?: number;
  user_name?: string;
  location_id?: number;
  customer_name?: string;
  fileLocation?: string;
}

export interface ResolverConfig {
    service: any;
    method: string;
}